import { useState } from "react";

import HeaderInfo from "../utils/HeaderInfo";
import LikesIsDone from "../utils/LikesIsDone";
import CommentMain from "../comment/CommentMain";
import useAuth from "../../hooks/useAuth";
import { DISPLAYING_FOR } from "../../config/AppEnums";

import "./css/answer.css";

import dateSlicer from "../../functions/dateSlicer";

const Answer = ({
    answer,
    isUserAuthenticated,
    updateableAnswers,
    setUpdateableAnswers
}) => {
    const { auth } = useAuth();
    const [updateableAnswerBody, setUpdateableAnswerBody] = useState(answer.answerBody);
    const [updateableUpdatedOn, setUpdateableUpdatedOn] = useState(answer.updatedOn);

    return (
        <div id={answer._id} className="answer">
            <HeaderInfo
                displayingFor={DISPLAYING_FOR.ANSWER}
                userId={answer.answeredById}
                name={answer.answeredBy}
                askedOn={dateSlicer(answer.answeredOn)}
                updatedOn={dateSlicer(updateableUpdatedOn)}
                data={{
                    contentOf: "answer",
                    answerId: answer._id,
                    content: {
                        body: answer.answerBody
                    },
                    updateableData: {
                        setUpdateableAnswerBody,
                        setUpdateableUpdatedOn,
                        updateableAnswers,
                        setUpdateableAnswers
                    }
                }}
                isUserAuthenticated={answer.answeredById === auth.userId}
            // above mentioned "isUserAuthenticated" is different from "isUserAuthenticated in mentiond props"
            // this "isUserAuthenticated" is checking whether the answer giver is logged in or not
            // while "isUserAuthenticated mentioned in props" is checking whether the doubt asker is logged in or not
            />

            <div className="ans-body">
                {updateableAnswerBody.split("\n").map((text, key) => {
                    return (
                        <span key={key}>
                            {text}
                            <br />
                        </span>
                    );
                })}
            </div>

            <LikesIsDone
                displayingFor={DISPLAYING_FOR.ANSWER}
                displayingForId={answer._id}
                likedBy={answer.likedBy}
                likes={answer.likes}
                isDone={answer.answerWorked}
                isUserAuthenticated={isUserAuthenticated}
            />

            <div className="ans-comment-cnt">
                <CommentMain
                    comments={answer.comments}
                    commentForId={answer._id}
                    commentFor="answer"
                />
            </div>
        </div>
    );
}

export default Answer;